import { combineReducers } from 'redux';
import data from './data/reducer';
import error from './error/reducer';

const rootReducer = combineReducers({
  data,
  error,
});

export default rootReducer;
